import React from 'react'
import ReactPaginate from 'react-paginate';

function ReactPaginateComponent({ totalPages, itemsPerPage, onPageChange, currentPage, marginPagesDisplayed=5}) {
    return (
        <ReactPaginate
            previousLabel="<"
            nextLabel=">"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={totalPages}
            pageRangeDisplayed={itemsPerPage}
            marginPagesDisplayed={marginPagesDisplayed}
            onPageChange={onPageChange}
            containerClassName="pagination justify-content-center"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            activeClassName="active"
            
            hrefBuilder={(page, pageCount, selected) =>
                page >= 1 && page <= pageCount ? `/page/${page}` : '#'
            }
            hrefAllControls
            forcePage={currentPage}
            onClick={(clickEvent) => {
                //console.log('onClick', clickEvent);

            }}
        />
    )
}

export default ReactPaginateComponent;